// Pure helper: compute days overdue from a due_date.

export function daysOverdue(dueDate) {
  if (!dueDate) return null;
  const due = new Date(dueDate);
  if (Number.isNaN(due.getTime())) return null;
  const today = new Date();
  const msPerDay = 1000 * 60 * 60 * 24;
  return Math.floor((today - due) / msPerDay);
}
